var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOctFlorVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 655,
    viewBox: "0 0 1440 655",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M362.785 5.75242H1077.01M352.59 9.71721H1087.21M341.795 13.9178H1098M330.348 18.3708H1109.45M318.186 23.1015H1121.61M305.241 28.1382H1134.56M291.432 33.5109H1148.36M276.672 39.2533H1163.12M260.86 45.4053H1178.94M243.877 52.0122H1195.92M225.589 59.1274H1214.21M205.841 66.8095H1233.95M184.448 75.132H1255.35M161.197 84.1786H1278.6M135.837 94.0446H1303.96M108.062 104.85H1331.73M77.5156 116.733H1362.28M43.7601 129.866H1396.04M6.25761 144.456H1433.54M-35.6474 160.759H1475.44M-82.7825 179.098H1522.58M-136.188 199.875H1575.98M-197.208 223.613H1637M-267.595 250.997H1707.39M-349.682 282.933H1789.48M-446.655 320.66H1886.45M-562.965 365.909H2002.76M-705.037 421.182H2144.83M-882.496 490.222H2322.29M-1110.44 578.902H2550.24M2716.13 697L1044.95 2M2578.45 697L1022.53 2M2440.78 697L1000.11 2M2303.11 697L977.697 2M2165.44 697L955.28 2M2027.77 697L932.863 2M1890.1 697L910.446 2M1752.43 697L888.029 2M1614.76 697L865.611 2M1477.09 697L843.194 2M1339.42 697L820.777 2M1201.75 697L798.36 2M1064.08 697L775.941 2M926.404 697L753.524 2M788.734 697L731.106 2M651.062 697L708.689 2M513.392 697L686.272 2M375.721 697L663.855 2M238.05 697L641.437 2M100.379 697L619.02 2M-37.291 697L596.603 2M-174.963 697L574.184 2M-312.633 697L551.767 2M-450.305 697L529.35 2M-587.975 697L506.932 2M-725.645 697L484.515 2M-863.317 697L462.098 2M-1000.99 697L439.681 2M-1138.66 697L417.263 2M-1276.33 697L394.846 2M-1414 697H2853.8L1067.37 2H372.429L-1414 697Z",
    stroke: "url(#paint0_linear_7893_13451)",
    strokeOpacity: 0.8,
    strokeWidth: 3.53156,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7893_13451",
    x1: 719.898,
    y1: 2,
    x2: 719.898,
    y2: 697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00520833,
    stopColor: "#E8E8DB",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#E8E8DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8DB",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctFlorVector);
export default __webpack_public_path__ + "static/media/oct-flor-vector.5ed5ccee2de945975bb315b220cee23c.svg";
export { ForwardRef as ReactComponent };